import TareasAdminPage from "../components/tareasAdmin/TareasAdminPage"

const TareasAdministracion = () => <TareasAdminPage />

export default TareasAdministracion